var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "education-infos--item" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "label", attrs: { md: "4" } },
            [_vm._t("label")],
            2
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { md: "8" } }, [_vm._t("content")], 2)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }